import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/admin/login");
      return;
    }
    const sessionId = decodeURIComponent(match[1]);
    (async () => {
      try {
        const r = await api.post("/auth/session", { session_id: sessionId });
        setUser(r.data);
        // Clear hash
        window.history.replaceState(null, "", "/admin");
        navigate("/admin", { replace: true, state: { user: r.data } });
      } catch (e) {
        navigate("/admin/login?error=1", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center text-neutral-500" data-testid="auth-callback">
      Signing you in…
    </div>
  );
}
